import {  HateoasResource, Resource} from '@lagoshny/ngx-hateoas-client';
import {ProcessExecution} from "./../V2/process-execution";

@HateoasResource('executions', { routeName: 'frontdoorResourceRoute' })
export class FrontdoorProcessExecution extends ProcessExecution {}
